import React from 'react';
import './DecisionTrailCards.css';

type Props = {history:any; upcoming:any[]; buckets:any[]; at:(v:string)=>string; money:(v:number)=>string};
const price=(value:any)=>Number.isFinite(Number(value))&&Number(value)>1?Number(value).toFixed(2):'—';
const field=(label:string,value:React.ReactNode,detail?:string)=>(
  <div className="decision-fact"><span>{label}</span><strong>{value}</strong>{detail&&<small>{detail}</small>}</div>
);
const label=(value:any)=>String(value||'').replace(/_/g,' ');

export default function DecisionTrailCards({history,upcoming,buckets,at,money}:Props){
  const estimates=new Map(upcoming.map(row=>[row.queue_id,row]));
  return <div className="decision-cards">
    {history.rows.map((row:any)=>{
      const estimate=estimates.get(row.queue_id);
      const stake=row.stake??(estimate?.staking?.status==='READY'?estimate.stake:null);
      const stakeNote=row.stake!=null?(row.offer_status==='NOT_OFFERED'?'Calculated · no order':'Offered stake'):stake!=null?'Estimated · may change':'No stake recorded';
      const bucket=buckets.find(b=>b.policy_id===row.policy_id)?.label||row.policy_id||'—';
      const result=row.result?label(row.result):row.offer_status==='NOT_OFFERED'&&row.race_result?'Race: '+label(row.race_result):'Pending';
      return <details className="decision-card" key={row.queue_id}>
        <summary>
          <div className="decision-heading"><div>
            <strong>{row.horse_number?row.horse_number+'. ':''}{row.runner}</strong>
            <span>{row.track} · Race {row.race} · {row.market_type}</span>
            {row.start_time&&<span className="decision-race-time">Race time {at(row.start_time)} Sydney</span>}
          </div><div className="decision-outcome"><span>{result}</span>
            {row.pnl!=null&&<strong className={Number(row.pnl)>=0?'positive':'negative'}>Net {money(Number(row.pnl))}</strong>}
          </div></div>
          <div className="decision-facts">
            {field('Rated price',price(row.rated_price))}
            {field('Market price',price(row.market_price),row.market_price_basis||'No recorded quote')}
            {field('Stake',stake!=null?money(Number(stake)):'—',stakeNote)}
            {field('Bet bucket',bucket)}
            {field('Offer status',label(row.offer_status).toLowerCase())}
            {field('Matched price',price(row.matched_price))}
          </div><span className="decision-expand">Decision details</span>
        </summary>
        <div className="decision-more">
          <dl><div><dt>First queued</dt><dd>{row.first_seen_at?at(row.first_seen_at):'—'}</dd></div>
            <div><dt>Stage</dt><dd>{label(row.stage)}</dd></div>
            <div><dt>Source</dt><dd>{row.engine_source||row.policy_id||'—'}</dd></div>
            <div><dt>Selection ID</dt><dd>{row.selection_id||'—'}</dd></div>
            <div><dt>Market ID</dt><dd>{row.market_id||'—'}</dd></div>
            <div><dt>Matched stake</dt><dd>{row.matched_stake!=null?money(Number(row.matched_stake)):'—'}</dd></div>
            {row.brain_decision_probability!=null&&<div><dt>Brain probability</dt><dd>{(Number(row.brain_decision_probability)*100).toFixed(1)}%</dd></div>}
            {row.reason&&<div className="decision-wide"><dt>Reason</dt><dd>{row.reason}</dd></div>}
            {row.pre_submit_quote?.price&&<div className="decision-wide"><dt>Pre-submit quote</dt><dd>{price(row.pre_submit_quote.price)} at {at(row.pre_submit_quote.observed_at)}</dd></div>}
            {row.race_result&&<div><dt>Race result</dt><dd>{label(row.race_result)}</dd></div>}
          </dl>
          {!!row.events?.length&&<div className="decision-events"><strong>{row.events.length} recorded change{row.events.length===1?'':'s'}</strong>
            <ol>{row.events.map((event:any,i:number)=><li key={i}>{at(event.at)} · {label(event.action)}
              {event.stake!=null?' · '+money(Number(event.stake)):''}{event.reason?' · '+event.reason:''}</li>)}</ol></div>}
        </div>
      </details>;
    })}
    {(history.brain_research||[]).map((row:any,i:number)=><details className="decision-card decision-research" key={'research-'+i}>
      <summary><div className="decision-heading"><div><strong>{row.runner}</strong><span>{row.track} · Race {row.race} · WIN · Brain research</span></div>
        <div className="decision-outcome"><span>Research only · {row.result||'pending'}</span></div></div>
        <div className="decision-facts">{field('Rated price',price(Number(row.brain_prob)>0?1/Number(row.brain_prob):null))}
          {field('Market price','—')}{field('Stake','—')}{field('Bet bucket','Brain research')}
          {field('Offer status','Not offered')}{field('Matched price','—')}</div><span className="decision-expand">Decision details</span></summary>
      <div className="decision-more"><p>{row.reason}</p><p>Model probability {(Number(row.brain_prob)*100).toFixed(1)}% · Decided {row.decided_at?at(row.decided_at):'—'}</p></div>
    </details>)}
    {(history.provisional||[]).map((row:any,i:number)=><details className="decision-card decision-research" key={'preview-'+i}>
      <summary><div className="decision-heading"><div><strong>{row.runner}</strong><span>{row.track} · Race {row.race} · WIN · Brain preview</span></div>
        <div className="decision-outcome"><span>Provisional</span></div></div>
        <div className="decision-facts">{field('Rated price',price(Number(row.brain_prob)>0?1/Number(row.brain_prob):null))}
          {field('Market price','—')}{field('Stake','—')}{field('Bet bucket','Brain preview')}
          {field('Offer status','Not offered')}{field('Matched price','—')}</div><span className="decision-expand">Decision details</span></summary>
      <div className="decision-more"><p>{row.reason}</p><p>Model probability {(Number(row.brain_prob)*100).toFixed(1)}%</p></div>
    </details>)}
  </div>;
}
